import "./Utils/sentry";
import {RouterProvider} from "react-router-dom";
import router from "./Utils/router";
import React from "react";
import {showRootComponent} from "./Utils/webHelper";

import './index.css'

import '@odx/icons/compat';

import '@odx/ui/core-theme.css';

// Load core icons for odx webcomps
import '@odx/icons';
import '@odx/icons/core';

// Load components for odx webcomps
import '@odx/foundation/loader';

// Load styles for odx webcomps
import '@odx/foundation/styles';

import "@odx/design-tokens/fonts";
import "@odx/design-tokens/css";

//showRootComponent(<HubModule />)
showRootComponent(
    <RouterProvider router={router} />
)
